"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
var useOnClickOutside_1 = require("./useOnClickOutside");
Object.defineProperty(exports, "useOnClickOutside", { enumerable: true, get: function () { return useOnClickOutside_1.useOnClickOutside; } });
